import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface ActionPopoverPopupProps extends ComponentProps<'div'> {}

function ActionPopoverPopup({ className, children, ...props }: ActionPopoverPopupProps) {
  return (
    <div
      className={twMerge(
        'bg-background-overlay flex w-fit items-center gap-1 overflow-hidden rounded-full p-1 shadow-lg outline-none',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export { ActionPopoverPopup }
